import React, { useEffect, useRef } from 'react';

export function MatrixRain() {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d', { alpha: true });
    if (!ctx) return;

    const resizeCanvas = () => {
      const { innerWidth, innerHeight } = window;
      const dpr = window.devicePixelRatio || 1;
      
      canvas.width = innerWidth * dpr;
      canvas.height = innerHeight * dpr;
      canvas.style.width = `${innerWidth}px`;
      canvas.style.height = `${innerHeight}px`;
      
      ctx.scale(dpr, dpr);
      ctx.clearRect(0, 0, innerWidth, innerHeight);
    };

    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    const fontSize = 14;
    const columns = Math.floor(window.innerWidth / fontSize);
    
    const groups = [];
    const numGroups = Math.floor(columns / 1.5); // Increased number of streams by reducing divisor
    
    for (let i = 0; i < numGroups; i++) {
      groups.push({
        x: Math.floor(Math.random() * columns) * fontSize,
        y: Math.random() * -100,
        speed: 1 + Math.random() * 2,
        length: 5 + Math.floor(Math.random() * 15),
        chars: [],
        lastUpdate: 0,
        updateInterval: 50 + Math.random() * 50
      });
    }

    const chars = '0123456789';
    let lastTime = 0;

    function draw(timestamp) {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      const deltaTime = timestamp - lastTime;
      lastTime = timestamp;

      groups.forEach(group => {
        if (timestamp - group.lastUpdate > group.updateInterval) {
          group.chars = Array(group.length).fill(0).map(() => 
            chars[Math.floor(Math.random() * chars.length)]
          );
          group.lastUpdate = timestamp;
        }

        group.chars.forEach((char, i) => {
          const fadeProgress = i / group.length;
          const alpha = Math.max(0, 0.5 * (1 - fadeProgress * fadeProgress));
          
          ctx.fillStyle = `rgba(34, 197, 94, ${alpha})`;
          ctx.font = `${fontSize}px monospace`;
          ctx.fillText(
            char, 
            group.x,
            group.y - (i * fontSize)
          );
        });

        group.y += group.speed * (deltaTime / 16);

        if (group.y - (group.length * fontSize) > canvas.height) {
          group.y = -100;
          group.x = Math.floor(Math.random() * columns) * fontSize;
          group.speed = 1 + Math.random() * 2;
          group.length = 5 + Math.floor(Math.random() * 15);
        }
      });

      requestAnimationFrame(draw);
    }

    requestAnimationFrame(draw);

    return () => {
      window.removeEventListener('resize', resizeCanvas);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        opacity: 0.5,
        zIndex: 0,
        backgroundColor: 'transparent',
      }}
    />
  );
}